import { Account as _Account } from './account';
import { AuthRequirements as _AuthRequirements } from './authRequirements';
import { MutableEntity as _ME, ImmutableEntity as IE } from './common';
import { Group as _Group } from './group';
import { Oidc as _Oidc } from './oidc';
import { Organization as _Organization } from './organization';
import { _SamlConfig as __SamlConfig } from './organization/samlConfig';
import { VerifiedDomain as _VerifiedDomain } from './organization/verifiedDomain';
import { OrganizationKarteMapping as _OrganizationKarteMapping } from './organizationKarteMapping';
import { Product as _Product } from './product';
import { Project as _Project } from './project';
import { ProjectKarteMapping as _ProjectKarteMapping } from './projectKarteMapping';
import { SignUpCode as _SignUpCode } from './signUpCode';
export namespace _Object {
  export import ImmutableEntity = IE;
  export import MutableEntity = _ME;
  export import Account = _Account;
  export import AuthRequirements = _AuthRequirements;
  export import Group = _Group;
  export import Organization = _Organization;
  export import Project = _Project;
  export import Product = _Product;
  export import ProjectKarteMapping = _ProjectKarteMapping;
  export import OrganizationKarteMapping = _OrganizationKarteMapping;
  export import Oidc = _Oidc;
  export import SamlConfig = __SamlConfig;
  export import VerifiedDomain = _VerifiedDomain;
  export import SignUpCode = _SignUpCode;
}
